export default "__VITE_ASSET__CGGSwhl5__"